import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SchemaEndpoints } from '@apis/cas';
import { DataPackageService } from '@apis/cas/generated';
import { AuthService } from '@core/auth.service';
import { environment } from '@environments/environment';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-schema',
  imports: [FormsModule],
  templateUrl: './schema.component.html',
  styleUrl: './schema.component.css',
})
export class SchemaComponent {
  schemaEndpoints = inject(SchemaEndpoints);
  dataPackageService = inject(DataPackageService);
  environment = environment;
  authService = inject(AuthService);
  dataInstanceIdInput = signal('');

  async isLoggedIn() {}

  // get schema
  async getSchema() {
    console.log('Getting schema');
    const schema = await firstValueFrom(this.schemaEndpoints.getSchema());
    //get the first value from the observable
    console.log(schema);
    console.log(JSON.stringify(schema));
  }

  async getDataPackage() {
    //first get the datapackage version and check if it is stored in the cache
    console.log('Getting data package version');
    const version = await firstValueFrom(
      this.dataPackageService.getDataPackageVersion(environment.defaultGame, environment.dataPackage, undefined, undefined, {
        httpHeaderAccept: 'text/text' as '*/*',
      }),
    );
    console.log('Data package version:', version);

    console.log('Getting data package');
    const dataPackageObservable = this.dataPackageService.getDataPackage(
      environment.defaultGame,
      environment.dataPackage,
      undefined,
      undefined,
      {
        httpHeaderAccept: 'application/json' as '*/*',
      },
    );

    //get the first value from the observable
    const dataPackage = await firstValueFrom(dataPackageObservable);
    console.log(dataPackage);
  }

  async loadDataPackage() {
    console.log('Parsing data package');
    // eslint-disable-next-line no-unused-vars
    const dataPackage = await firstValueFrom(
      this.dataPackageService.getDataPackage(environment.defaultGame, environment.dataPackage, undefined, undefined, {
        httpHeaderAccept: 'application/json' as '*/*',
      }),
    );
    // eslint-disable-next-line no-unused-vars
    const schema = await firstValueFrom(this.schemaEndpoints.getSchema());
    // const dataReader = new LpDataInstanceReader(dataPackage, schema);
    // const storyActivities = dataReader.getInstancesByType('StoryActivity');
    // console.log(storyActivities);
  }

  async getDataInstance(dataInstanceId: string) {
    if (!dataInstanceId) {
      console.error('Data instance id is required');
      return;
    }
    console.log('Getting data instance');
    const dataInstance = this.dataPackageService.getDataInstance(
      environment.defaultGame,
      environment.dataPackage,
      '_',
      dataInstanceId,
      undefined,
      undefined,
      undefined,
      {
        httpHeaderAccept: 'application/json' as '*/*',
      },
    );
    console.log(await firstValueFrom(dataInstance));
  }
}
